import { useEffect, useState } from 'react';
import type { OrderListItem } from '@/api/types';
import { DEFAULT_WORK_CARD_SETTINGS, WorkCard, type WorkCardSettings } from './OrderCards';
import s from './OrderCardSettingsSheet.module.css';

const FIELDS: { key: Exclude<keyof WorkCardSettings, 'compact'>; title: string; note?: string }[] = [
  { key: 'people', title: '业务员 / 跟单' },
  { key: 'lines', title: '订单详情', note: '标准模式最多显示 2 行' },
  { key: 'due', title: '最迟交货日期 + 倒计时' },
  { key: 'orderDate', title: '下单日期' },
  { key: 'shippingMethod', title: '运输方式' },
  { key: 'reminders', title: '修改记录 / 提醒 / 异常' },
  { key: 'stock', title: '库存状态' },
  { key: 'platformNo', title: '1688 订单号' },
];

export function OrderCardSettingsSheet({ value, preview, onSave, onClose }: {
  value: WorkCardSettings;
  preview?: OrderListItem;
  onSave: (value: WorkCardSettings) => void;
  onClose: () => void;
}) {
  const [draft, setDraft] = useState(value);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return <div className={s.backdrop} onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className={s.sheet} role="dialog" aria-modal="true" aria-label="卡面显示">
      <header className={s.head}><button type="button" onClick={onClose} aria-label="关闭卡面显示">×</button><span><b>卡面显示</b><small>我的待办 · 只对你生效</small></span></header>
      <div className={s.body}>
        <div className={s.segment} role="group" aria-label="卡片密度"><button type="button" className={!draft.compact ? s.on : ''} aria-pressed={!draft.compact} onClick={() => setDraft((old) => ({ ...old, compact: false }))}>标准</button><button type="button" className={draft.compact ? s.on : ''} aria-pressed={draft.compact} onClick={() => setDraft((old) => ({ ...old, compact: true }))}>紧凑</button></div>
        <div className={s.preview}>{preview ? <div className={s.previewCard}><WorkCard o={preview} to="#" settings={draft} /></div> : <p>当前列表没有订单，切换字段后可在列表中查看效果。</p>}</div>
        <div className={s.title}><b>卡面字段</b><small>订单号、状态、客户名称固定显示</small></div>
        <div className={s.fields}>{FIELDS.map((field) => <button type="button" key={field.key} className={s.field} role="switch" aria-checked={draft[field.key]} onClick={() => setDraft((old) => ({ ...old, [field.key]: !old[field.key] }))}><span><b>{field.title}</b>{field.note && <small>{field.note}</small>}</span><i className={draft[field.key] ? s.switchOn : ''} /></button>)}</div>
        <p className={s.note}>紧凑模式将订单详情压成一行，并隐藏业务员与跟单行。全部订单的台账卡保持系统固定顺序。</p>
      </div>
      <footer className={s.foot}><button type="button" onClick={() => setDraft(DEFAULT_WORK_CARD_SETTINGS)}>恢复默认</button><button type="button" onClick={() => onSave(draft)}>完成</button></footer>
    </section>
  </div>;
}
